import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import './SharedStyleSheet.css';

const products = [
  { id: '10min', name: '10-minute card', price: 5, features: ['.50 $/min', 'Saved Sessions', 'Try Us'] },
  { id: '30min', name: '30-minute card', price: 10, features: ['.35 $/min', 'Saved Sessions', 'Most Popular'] },
  { id: '120min', name: '120-minute card', price: 30, features: ['.25 $/min', 'Saved Sessions', 'Best Value'] },
];

function Pricing() {
  const { t } = useTranslation();

  return (
    <div className='App'>
      <Container className="pricing-page">
        <Row className="mt-5">
          <Col xs={12}>
            <h3 className="text-center">{t('pricingPlans')}</h3>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {products.map((product) => (
            <Col key={product.id} xs={12} md={4}>
              <Card className={product.id === '30min' ? 'pricing-plan selected' : 'pricing-plan'}>
                <Card.Body>
                  <Card.Title className="plan-header">{product.name}</Card.Title>
                  <Card.Text className="plan-price">${product.price}</Card.Text>
                  <ul>
                    {product.features.map((feature) => (
                      <li key={feature}>{feature}</li>
                    ))}
                  </ul>
                  <Button variant="primary">{t('selectPlan')}</Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default Pricing;
